export default [
  {
    path: "pudo",
    name: "pudo",
    component: () => import("@/views/JoinUs/Pudo/index.vue"),
    meta: {
      mobilePath: "/pudo",
      title: "成为我们的PUDO站点",
    },
  },
  {
    path: "franquia",
    name: "franquia",
    component: () => import("@/views/JoinUs/Franquia/index.vue"),
    meta: {
      mobilePath: "/franquia",
      title: "成为我们的加盟商",
    },
  },
  {
    path: "tender",
    name: "tenderInfo",
    component: () => import("@/views/JoinUs/tender/index.vue"),
    meta: {
      title: "招采信息",
    },
  },
  {
    path: "tender/:id",
    name: "tenderInfoDetail",
    component: () => import("@/views/JoinUs/tender/index.vue"),
    meta: {
      title: "招采信息详情",
    },
  },
];
